<template>
  <bdg-input-template
    :name="name"
    @focusout="onFocusout"
    :invalid="isInvalid"
    :required="required"
    :removable="removable"
    @remove="$emit('remove')"
  >
    <div class="flex items-center">
      <input
        class="flex-grow mr-3"
        :class="{ invalid: isInvalid && !computedPhoneNumber }"
        type="text"
        :name="name"
        :placeholder="placeholder"
        :disabled="disabled"
        :required="required"
        v-model="computedPhoneNumber"
      />

      <dropdown
        :class="{ invalid: isInvalid && !computedType }"
        :name="null"
        placeholder="select one"
        :options="phoneTypes"
        :disabled="disabled"
        :required="required"
        v-model="computedType"
      />
    </div>
  </bdg-input-template>
</template>

<script>
import Dropdown from "./Dropdown";
import BdgInputTemplate from "./BdgInputTemplate";
import { Phone } from "../../models/Phone";

export default {
  name: "BdgPhoneNumberField",
  extends: BdgInputTemplate,
  components: { BdgInputTemplate, Dropdown },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    value: { type: Phone, default: () => new Phone() },
    disabled: Boolean
  },
  data() {
    return {
      phoneTypes: [
        { label: "Mobile", value: "mobile" },
        { label: "Home", value: "home" },
        { label: "Office", value: "office" }
      ],
      isInvalid: false
    };
  },
  computed: {
    computedPhoneNumber: {
      get() {
        return this.value.number;
      },
      set(val) {
        this.$emit(
          "input",
          new Phone({ id: this.value.id, number: val, type: this.computedType })
        );
      }
    },
    computedType: {
      get() {
        return this.value.type;
      },
      set(val) {
        this.$emit(
          "input",
          new Phone({
            id: this.value.id,
            number: this.computedPhoneNumber,
            type: val
          })
        );
      }
    },
    isValid() {
      return (
        (!this.computedPhoneNumber && !this.computedType) ||
        (this.computedPhoneNumber && this.computedType)
      );
    }
  },
  methods: {
    onFocusout() {
      this.isInvalid = !this.isValid;
    }
  }
};
</script>

<style scoped></style>
